module.exports = __webpack_public_path__ + "img/logo-dark.ebd0dc5f.png";